import { PAYMENT_STATUS } from "pages/AccountSettlementHistoryOrderId/constants/PaymentStatus";
import { useMemo } from "react";
import { getPaymentType } from "utility/getPaymentType";

import type { OrderData } from "../../types/OrderData";
import type { PaymentStatus } from "@spwn/types/spwn";
import type { Store } from "store";

type UseOrderDataInput = {
  transaction?: Store["purchase"]["activeTransactionMap"][string];
};

type UseOrderDataOutput = {
  orderData: OrderData | null;
};

type PaymentStatuses = typeof PAYMENT_STATUS;
const paymentStatus: Record<string, PaymentStatuses[keyof PaymentStatuses]> =
  PAYMENT_STATUS;

const getPaymentStatus = (status: string | null): PaymentStatus => {
  if (status === null) return PAYMENT_STATUS.UNPROCESS;
  return paymentStatus[status] ?? PAYMENT_STATUS.UNPROCESS;
};

const getPurchasedCount = (productCountMap: Record<string, number>): number => {
  return Object.values(productCountMap).reduce(
    (acc, curr) => acc + (curr ?? 0),
    0
  );
};

export const useOrderData = (input: UseOrderDataInput): UseOrderDataOutput => {
  const { transaction } = input;

  const orderData: OrderData | null = useMemo(() => {
    if (!transaction) return null;

    return {
      orderId: transaction.orderId ?? 0,
      purchasedAt: transaction.createdAt?.seconds ?? 0,
      purchasedCount: getPurchasedCount(transaction.productCountMap ?? {}),
      purchasedType: getPaymentType(transaction.payType),
      paymentStatus: getPaymentStatus(transaction.status),
      totalPrice: transaction.totalPrice,
      shippingFee: transaction.shippingFee ?? 0,
      serviceFee: transaction.serviceFee ?? 0,
      settlementFee: transaction.settlementFee ?? 0,
    };
  }, [transaction]);

  return { orderData };
};
